import gql from 'graphql-tag';

import embeddedIntegrationEmailFragment from './embeddedIntegrationEmailFragment';
import dokkioThreadFragment from './dokkioThreadFragment';

export const integrationThreadFragment = gql`
  fragment integrationThreadFragment on IntegrationThread {
    accountID
    dokkioClass
    integrationID
    remoteID
    providerThreadID
    integrationEmails {
      ...embeddedIntegrationEmailFragment
    }
    dokkioThread {
      ...dokkioThreadFragment
    }
  }
  ${embeddedIntegrationEmailFragment}
  ${dokkioThreadFragment}
`;
export default integrationThreadFragment;
